export default [
    {
        title: "mainmenu.secure-exports",
        route: "secure-exports",
        icon: "file-export",
        class: "d-none d-sm-block",
        resource: "secure-exports",
        action: "read",
    },
];
